document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // Expanded Collapse
  // =========================
  function updateExpanded() {
    document.querySelectorAll(".js-expanded").forEach(function (el) {
      const hasShowBlockParent = el.closest(".show-block");
      el.setAttribute("aria-expanded", hasShowBlockParent ? "true" : "false");
    });
  }

  updateExpanded();

  document.addEventListener("click", function () {
    updateExpanded();
  });

  // =========================
  // Third party warning
  // =========================
  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");

      if (!href) return;
      if (href.toLowerCase().includes(".pdf")) return;
      if (!isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      if (link.classList.contains("et_pb_button")) {
        link.removeAttribute("aria-label");

        if (!link.querySelector(".visually-hidden")) {
          const span = document.createElement("span");
          span.className = "visually-hidden";
          span.textContent = warningText;
          link.appendChild(span);
        }

        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");

      if (!aria || !aria.includes(warningText)) {
        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =========================
  // PDF warning
  // =========================
  function handlePdfLinks() {
    const pdfLinks = document.querySelectorAll('a[href*=".pdf"]');

    pdfLinks.forEach(function (link) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const pdfWarning = "This PDF will open in a new tab";
      const aria = link.getAttribute("aria-label");
      const text = link.textContent.trim();

      if (!aria) {
        link.setAttribute(
          "aria-label",
          text ? text + ", " + pdfWarning : pdfWarning,
        );
      } else if (!aria.includes(pdfWarning)) {
        link.setAttribute("aria-label", aria + ", " + pdfWarning);
      }
    });
  }

  setTimeout(handlePdfLinks, 300);

  // =========================
  // Email & phone labels
  // =========================
  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      const href = el.getAttribute("href");

      if (
        el.hasAttribute("aria-label") ||
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "").trim();
        el.setAttribute("aria-label", "Email Address: " + email);
      }

      if (href.startsWith("tel:")) {
        const text = el.textContent.trim();
        el.setAttribute("aria-label", "Phone number: " + text);
      }
    });

  // =========================
  // aria-hidden on <br>
  // =========================
  document.querySelectorAll("br, hr").forEach(function (el) {
    el.setAttribute("aria-hidden", "true");
  });

  // =========================
  // Empty headings
  // =========================
  setTimeout(function () {
    document.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(function (el) {
      const text = el.textContent.trim();
      const hasMeaningfulMedia = el.querySelector(
        "img, svg, picture, video, iframe",
      );
      const hasAriaLabel = el.getAttribute("aria-label");

      if (!text && !hasMeaningfulMedia && !hasAriaLabel) {
        el.remove();
      }
    });
  }, 1000);
  // =========================
  // Checkout process Focus
  // =========================

  function focusTarget(selector) {
    setTimeout(function () {
      var target = document.querySelector(selector);

      if (target) {
        target.setAttribute("tabindex", "-1");
        target.focus();
      }
    }, 500);
  }

  document.addEventListener("click", function (e) {
    // Choose pickup button → focus h2
    if (e.target.closest(".btn-choose-pickup")) {
      focusTarget("h2");
    }

    // Review kit button → focus h2
    if (e.target.closest(".btn-review-kit")) {
      focusTarget("h2");
    }

    // Checkout now button → focus h1
    if (e.target.closest(".btn-checkout-now")) {
      focusTarget("h1");
    }
    // Checkout now button → focus h1
    if (e.target.closest(".btn-checkout-later")) {
      focusTarget("h1");
    }
  });
  ///
});
